"use strict";

import Masonry from 'masonry-layout/masonry';
import imagesLoaded from 'imagesloaded/imagesloaded';

let grid = document.querySelector('.teaser-group');

if (grid) {
    let width = grid.clientWidth;

    if (
        window.innerWidth > 709
        && window.innerWidth < 1200
    ) {
        width = (grid.clientWidth / 2) - 12;
    } else if (window.innerWidth > 1199) {
        width = (grid.clientWidth / 3) - (2/3 * 24);
    }

    let masonry = new Masonry(grid, {
        itemSelector: '.teaser',
        columnWidth: width,
        gutter: 24,
        percentPosition: true,
        resize: true
    });

    imagesLoaded(grid, () => {
        masonry.layout();
    });
}
